import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

const useQuery = (params) => {
  const { search } = useLocation()
  const queryParams = useMemo(() => new URLSearchParams(search), [search])

  if (!params) {
    return queryParams
  }
  return Object.fromEntries(params.map((paramKey) => [paramKey, queryParams.get(paramKey)]))
}

useQuery.propTypes = {
  params: PropTypes.array,
}

export default useQuery
